export const EXTENSION_URL =
  "https://chromewebstore.google.com/detail/grensa-ai-support-assista/agolglidnfabinkppmoidcbbilknoapi";
